/**
 * Module-level caches that belong to the signed-in user (hub list, per-client
 * config, shared in-flight GETs …) register a reset here; `clearSessionCaches`
 * runs them when the session is cleared (sign-out), so the next user never
 * reads what the last one fetched. The registry sits below both the auth
 * service and the features, so neither imports the other.
 */
const resets = new Set<() => void>();

/** Run `reset` whenever the session is cleared. Returns an unregister. */
export const onSessionClear = (reset: () => void): (() => void) => {
  resets.add(reset);
  return () => {
    resets.delete(reset);
  };
};

/** Forget everything registered with `onSessionClear`. */
export const clearSessionCaches = (): void => {
  resets.forEach((reset) => {
    try {
      reset();
    } catch (err) {
      console.error('Session cache reset failed:', err);
    }
  });
};
